import { render, staticRenderFns } from "./AccountConnection.vue?vue&type=template&id=2ef35fe4"
import script from "./AccountConnection.vue?vue&type=script&lang=js"
export * from "./AccountConnection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports